import { UserPlus } from "@tamagui/lucide-icons";
import { Pressable } from "react-native";
import { Circle, useMedia, View, XStack } from "tamagui";
import { Label } from "./Label";
import { AvatarSize, AvatarSizeLookup, UserAvatar } from "./UserAvatar";

type Props = {
  userUids: string[];
  size?: AvatarSize;
  onPress?: () => void;
  onSharePressed?: () => void;
};

const MAX_USERS = 4;
const OVERLAP_PIXELS = 8;

export const UserAvatarGroup = ({
  userUids,
  onPress,
  onSharePressed,
}: Props) => {
  const usersMoreToShow = Math.max(0, userUids.length - MAX_USERS);
  const usersToShow = userUids.slice(0, MAX_USERS);
  const media = useMedia();

  const size = media.gtSm ? AvatarSize.Medium : AvatarSize.Smaller;
  const sizeInPx = AvatarSizeLookup[size];

  const hasUsers = userUids.length > 1;

  return (
    <Pressable disabled={!onPress} onPress={onPress}>
      <View paddingHorizontal="$larger" $gtSm={{ paddingHorizontal: 0 }}>
        <XStack width={"100%"} height={sizeInPx}>
          {usersToShow.map((userUid, i) => (
            <View
              key={userUid}
              position="absolute"
              left={(sizeInPx - OVERLAP_PIXELS) * i}
              zIndex={i + 1}
            >
              <UserAvatar userUid={userUid} size={size} />
            </View>
          ))}

          {usersMoreToShow > 0 && (
            <Circle
              size={sizeInPx}
              backgroundColor={"$divider"}
              position="absolute"
              left={(sizeInPx - OVERLAP_PIXELS) * usersToShow.length}
              zIndex={MAX_USERS + 1}
            >
              <Label>+{usersMoreToShow}</Label>
            </Circle>
          )}

          {!!onSharePressed && (
            <Pressable
              style={{
                position: "absolute",
                right: 0,
              }}
              onPress={onSharePressed}
            >
              <XStack gap={"$medium"} alignItems={"center"}>
                {!hasUsers && <Label>Invite</Label>}

                <Circle
                  size={sizeInPx}
                  backgroundColor={hasUsers ? "$divider" : "$primary"}
                >
                  <UserPlus size={sizeInPx / 2} />
                </Circle>
              </XStack>
            </Pressable>
          )}
        </XStack>
      </View>
    </Pressable>
  );
};
